import { Box } from "@mui/material";
import React from "react";
import { CheckStickyNotesCondition } from "../../../../../../common/interfaces/CheckStickyNotesCondition";
import styles from "./ConditionSelector.module.scss";

export const ConditionSelector = React.memo(
  (
    props: CheckStickyNotesCondition & {
      onOpenLevelsClick: () => void;
      onSearchClick: () => void;
    }
  ) => {
    return (
      <Box id="conditionSelector" className={styles.condition}>
        <Box className={styles.paragraph}>
          <Box className={styles.button} onClick={props.onOpenLevelsClick}>
            {props.openLevels.join(" / ")}
          </Box>
          が対象
          <Box className={styles.spacer} />
          <Box
            className={`${styles.button} ${styles.searchButton}`}
            onClick={props.onSearchClick}
          >
            検索
          </Box>
        </Box>
      </Box>
    );
  }
);
